import { render, staticRenderFns } from "./ProfileBioPanel.vue?vue&type=template&id=3748f2fa&"
import script from "./ProfileBioPanel.vue?vue&type=script&lang=js&"
export * from "./ProfileBioPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports